import { createInjectionKey as t } from "../../_utils/vue/create-injection-key.js";
const n = t("n-tabs");
export {
  n as tabsInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tabs/src/interface.js
// module id = 494
// module chunks = 67